import Event from '../../core/Event';

export default class TermsRequested extends Event {
    public static type = 'TermsRequested';

    constructor() {
        super(TermsRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/TermsRequested.ts